document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
      menuButton.textContent = open ? 'Close' : 'Menu';
    });
    mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.textContent = 'Menu';
    }));
  }

  const heroVideo = document.querySelector('.hero-video');
  const videoToggle = document.querySelector('.video-toggle');
  if (heroVideo && videoToggle) {
    videoToggle.addEventListener('click', () => {
      if (heroVideo.paused) {
        heroVideo.play();
        videoToggle.textContent = 'Pause';
        videoToggle.setAttribute('aria-label', 'Pause background video');
      } else {
        heroVideo.pause();
        videoToggle.textContent = 'Play';
        videoToggle.setAttribute('aria-label', 'Play background video');
      }
    });
  }

  const tabs = document.querySelectorAll('[data-timeline]');
  tabs.forEach(tab => tab.addEventListener('click', () => {
    tabs.forEach(item => item.classList.remove('active'));
    document.querySelectorAll('[data-panel]').forEach(panel => panel.classList.remove('active'));
    tab.classList.add('active');
    document.querySelector(`[data-panel="${tab.dataset.timeline}"]`)?.classList.add('active');
  }));

  function updateVariant(input) {
    const form = input.closest('.product-form');
    if (!form) return;
    form.querySelectorAll('label').forEach(label => label.classList.remove('selected'));
    input.closest('label')?.classList.add('selected');
    const scope = form.closest('.product-hero') || form.closest('.offer-section') || form;
    scope.querySelectorAll('[data-selected-price]').forEach(node => node.textContent = input.dataset.price || '');
    const targetImage = document.querySelector('[data-main-image]') || document.querySelector('#offer-image');
    if (targetImage && input.dataset.image) targetImage.src = input.dataset.image;
  }
  document.querySelectorAll('.product-form input[name="id"]').forEach(input => {
    input.addEventListener('change', () => updateVariant(input));
  });

  document.querySelectorAll('[data-qty-minus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input');
    input.value = Number(input.value || 1) + 1;
  }));

  document.querySelectorAll('[data-buy-now]').forEach(button => button.addEventListener('click', async () => {
    const form = button.closest('.product-form');
    const variant = form?.querySelector('input[name="id"]:checked') || form?.querySelector('input[name="id"]');
    const quantity = form?.querySelector('input[name="quantity"]');
    if (!variant) return;
    button.disabled = true;
    const original = button.textContent;
    button.textContent = 'ADDING…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(variant.value), quantity: Number(quantity?.value || 1)}]})
      });
      if (!response.ok) throw new Error('Could not add item');
      window.location.assign('/checkout');
    } catch (error) {
      button.disabled = false;
      button.textContent = original;
      alert('We could not start checkout. Please try Add to Bag.');
    }
  }));

  const galleryButtons = [...document.querySelectorAll('[data-gallery-image]')];
  const mainImage = document.querySelector('[data-main-image]');
  let galleryIndex = 0;
  function showGallery(index) {
    if (!galleryButtons.length || !mainImage) return;
    galleryIndex = (index + galleryButtons.length) % galleryButtons.length;
    galleryButtons.forEach(button => button.classList.remove('active'));
    const button = galleryButtons[galleryIndex];
    button.classList.add('active');
    mainImage.src = button.dataset.galleryImage;
    const counter = document.querySelector('[data-gallery-current]');
    if (counter) counter.textContent = String(galleryIndex + 1).padStart(2, '0');
    button.scrollIntoView({block: 'nearest', inline: 'nearest'});
  }
  galleryButtons.forEach((button, index) => button.addEventListener('click', () => showGallery(index)));
  document.querySelector('.gallery-arrow.prev')?.addEventListener('click', () => showGallery(galleryIndex - 1));
  document.querySelector('.gallery-arrow.next')?.addEventListener('click', () => showGallery(galleryIndex + 1));
  if (mainImage) {
    let startX = 0;
    mainImage.addEventListener('touchstart', event => { startX = event.changedTouches[0].screenX; }, {passive: true});
    mainImage.addEventListener('touchend', event => {
      const distance = event.changedTouches[0].screenX - startX;
      if (Math.abs(distance) > 45) showGallery(galleryIndex + (distance < 0 ? 1 : -1));
    }, {passive: true});
  }
});
